module.exports = __webpack_public_path__ + "static/media/4 nautical ship waves thunderstorm pirate pirates.1280x1920.eeccd2fe.webp";